import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  Signal,
} from '@angular/core';

import type { Entry } from './utils';
import { wrapContent } from './utils';

/**
 * Component that wraps links in the content with anchor tags.
 * You may need it if you want to avoid using innerHTML, but need to display links anyway.
 */
@Component({
  selector: 'rt-link-wrapper',
  template: `
    @for (entry of wrappedContent(); track $index) {
      @if (entry.type === 'url' || entry.type === 'email') {
        <a [href]="entry.protocol + entry.value" target="_blank">
          {{ entry.keepProtocol ? entry.protocol + entry.value : entry.value }}
        </a>
      } @else {
        {{ entry.value.trim() }}
        @if (entry.value.includes('\\n') && isMultiline()) {
          <br />
        }
      }
    }
  `,
  styles: `
    a:before {
      content: ' ';
    }
    a:after {
      content: ' ';
    }
  `,
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkWrapperComponent {
  public content = input.required<string>();

  public forceNoProtocol = input<boolean, boolean | string>(false, { transform: booleanAttribute });

  public isMultiline = input<boolean, boolean | string>(false, { transform: booleanAttribute });

  protected wrappedContent: Signal<Entry[]> = computed(() =>
    wrapContent(this.content(), this.forceNoProtocol()),
  );
}
